import Image from 'next/image'
import {FC} from 'react'
import {Settings} from 'react-slick'

import {getTmAcademyContent} from '@/content/tm-academy/tmAcademy'
import {useTranslation} from '@/i18n'
import {SLIDER_TRANSITION} from '@/theme/cssTransitions'
import {theme} from '@/theme/theme'
import {useLanguage} from '@/utils/i18n/language'
import {
  MOBILE_MAX_WIDTH,
  MOBILE_SCREENSIZE,
  USER_TABLET_MAX_WIDTH,
} from '@/utils/styles/breakpoints'

import Carousel from '../common/carousel/Carousel'
import {Text, TextVariant} from '../common/content/Text'

const settings: Settings = {
  infinite: true,
  speed: SLIDER_TRANSITION,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: false,
  responsive: [
    {
      breakpoint: USER_TABLET_MAX_WIDTH,
      settings: {
        slidesToShow: 3,
        dots: true,
      },
    },
    {
      breakpoint: MOBILE_MAX_WIDTH,
      settings: {
        slidesToShow: 2,
        dots: true,
      },
    },
  ],
}

export const EndorsersCarousel: FC<React.PropsWithChildren<unknown>> = () => {
  const {t} = useTranslation()
  const language = useLanguage()
  const {title, list} = getTmAcademyContent(language).endorsers

  return (
    <>
      <div className="endorsers">
        <Text variant={TextVariant.h2} align="center">
          {t(title)}
        </Text>
        <div className="endorsers-carousel">
          <Carousel settings={settings}>
            {list.map(({imageSrc, imageAlt, linkHref}) => (
              <a
                key={linkHref}
                href={linkHref}
                rel="noopener noreferrer"
                target="_blank"
                className="logo-wrapper"
              >
                <Image
                  src={imageSrc}
                  alt={imageAlt}
                  style={{objectFit: 'contain'}}
                  className="client-logo"
                  width={170}
                  height={36}
                />
              </a>
            ))}
          </Carousel>
        </div>
      </div>

      <style jsx>{`
        .endorsers-carousel {
          margin-top: ${theme.spacing[6]};
        }
        @media ${MOBILE_SCREENSIZE} {
          .endorsers-carousel {
            margin-top: ${theme.spacing[5]};
            margin-bottom: 0;
          }
        }
      `}</style>

      <style jsx global>{`
        .endorsers-carousel .slick-slider {
          max-width: inherit;
        }

        .endorsers-carousel .slick-slide {
          text-align: center;
          padding: 0 ${theme.spacing[3]};
        }
      `}</style>
    </>
  )
}
